var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94736 1.39382C7.09587 1.39382 8.0381 2.33605 8.0381 3.48456V5.57529H3.85663V3.48456C3.85663 2.33605 4.79885 1.39382 5.94736 1.39382ZM9.43192 5.57529V3.48456C9.43192 1.56666 7.86527 0 5.94736 0C4.02946 0 2.46281 1.56666 2.46281 3.48456V5.57529H1.76589C1.39623 5.57529 1.0417 5.72214 0.780312 5.98354C0.518919 6.24493 0.37207 6.59945 0.37207 6.96912V12.5444C0.37207 12.9141 0.518919 13.2686 0.780312 13.53C1.0417 13.7914 1.39623 13.9382 1.76589 13.9382H10.1288C10.4985 13.9382 10.853 13.7914 11.1144 13.53C11.3758 13.2686 11.5227 12.9141 11.5227 12.5444V6.96912C11.5227 6.59945 11.3758 6.24493 11.1144 5.98354C10.853 5.72214 10.4985 5.57529 10.1288 5.57529H9.43192ZM1.76589 6.96912H10.1288V12.5444H1.76589V6.96912Z",
    fill: "#002E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLight);
export default __webpack_public_path__ + "static/media/lock-light.59621f0892e241cc71e6f4e89fee3b72.svg";
export { ForwardRef as ReactComponent };